import { debounce } from "lodash"

export const delayedFunction = debounce((func, value) => {
    if (value && value.length > 2) {
        func(value);
    }
}, 1000)